import colorWheelIcon from './color-wheel.png';

export const CategoryIcon = () => (
  <img alt="" height="20px" src={colorWheelIcon} width="20px" />
);
